<template>

    <div class="layout__container layout__padding-20-0">
        <div class="layout__padding-clear layout__width-800px">
            <StepGuide :stepCount="3"></StepGuide>
        </div>
        <div class="layout__padding-20-0">

            <!--{{this.voucherApplied}}<br>-->
            <!--{{this.job}}-->


            <div class="layout__width-100 colour__background-light-grey layout__position-left layout__padding-20px">
                <div class="layout__padding-clear layout__width-80">
                    <h3 class="text__align-center text__colour-teal layout__padding-20px">My Billing Details</h3>
                    <div class="component__columns-2">

                        <!--<div class="border"-->

                        <el-form :model="job" :rules="rules" ref="job" class="">
                            <el-form-item class="layout__padding__top-30px" prop="userReference">Your Reference<span
                                    class="text__colour-red">*</span>
                                <el-input
                                        class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right layout__border__all-2px-red"
                                        placeholder="Enter a reference"
                                        v-model="job.userReference"
                                        autofocus v-on:blur="updateReference()"></el-input>
                            </el-form-item>
                            <h4 class="layout__margin__bottom-20 layout__width-75 layout__position-right text__align-center text__colour-red">Please enter an order reference before continuing to review and place your order</h4>
                        </el-form>

                        <div class="layout__padding-40px-0">
                            <div class="layout__width-100">
                                <el-form :model="job">
                                    <el-form-item prop="voucherUsed" class="layout__padding__top-30px">Voucher Code
                                        <el-input v-model="job.voucherUsed" clearable
                                                  class="layout__width-75 layout__padding-clear layout__position-right"
                                                  placeholder="Enter a voucher code"></el-input>
                                    </el-form-item>
                                    <div class="layout__width-75 text__colour-teal layout__position-right text__direction-left-to-right">
                                        <p id="voucherNoticeSuccess"></p>
                                        <p id="voucherNoticeFail"></p>
                                    </div>

                                    <div class="layout__width-75 layout__padding-clear layout__position-right text__align-center text__size-12">
                                        <div class="layout__padding-10px-0">Voucher codes cannot be used in conjunction
                                            with any other offer.
                                        </div>
                                        <div>If the voucher code is greater than or equal to the additional offer amount
                                            the larger discount will be applied
                                        </div>
                                    </div>
                                    <div class="layout__width-75 layout__position-right">
                                        <div class="text__align-center layout__padding-20-0">
                                            <el-button
                                                    class="button-teal button__base layout__width-200px"
                                                    v-on:click="validateVoucher()">Apply Voucher
                                            </el-button>
                                        </div>
                                    </div>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <div class="component__columns-2 layout__border__left-1px">
                        <div class="layout__padding-0-20">
                            <el-form :model="billingAddress" :rules="rules" ref="billingAddress">
                                <el-form-item class="layout__padding__top-30px" prop="addr1">Address Line 1<span
                                        class="text__colour-red">*</span>
                                    <el-input
                                            class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                                            placeholder="Address Line 1"
                                            v-model="billingAddress.addr1"
                                            clearable
                                            :disabled="this.disabledAddress"
                                            v-on:blur="updateBillingAddress()"></el-input>
                                </el-form-item>
                                <el-form-item prop="addr2">Address Line 2
                                    <el-input
                                            class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                                            placeholder="Address Line 2"
                                            v-model="billingAddress.addr2"
                                            clearable :disabled="this.disabledAddress"
                                            v-on:blur="updateBillingAddress()"></el-input>
                                </el-form-item>
                                <el-form-item prop="addr3">Address Line 3
                                    <el-input
                                            class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                                            placeholder="Address Line 3"
                                            v-model="billingAddress.addr3"
                                            clearable :disabled="this.disabledAddress"
                                            v-on:blur="updateBillingAddress()"></el-input>
                                </el-form-item>
                                <el-form-item prop="town">Town/City<span class="text__colour-red">*</span>
                                    <el-input
                                            class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                                            placeholder="Town/City"
                                            v-model="billingAddress.town"
                                            clearable :disabled="this.disabledAddress"
                                            v-on:blur="updateBillingAddress()"></el-input>
                                </el-form-item>
                                <el-form-item prop="county">County<span class="text__colour-red">*</span>
                                    <el-input
                                            class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                                            placeholder="County"
                                            v-model="billingAddress.county"
                                            clearable :disabled="this.disabledAddress"
                                            v-on:blur="updateBillingAddress()"></el-input>
                                </el-form-item>
                                <el-form-item prop="postcode">Postcode<span class="text__colour-red">*</span>
                                    <el-input
                                            class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                                            placeholder="Postcode"
                                            v-model="billingAddress.postcode"
                                            clearable :disabled="this.disabledAddress"
                                            v-on:blur="updateBillingAddress()"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                </div>
            </div>


            <div class="layout__padding-clear layout__width-80" v-show="this.job.userReference != null && this.job.userReference != ''">
                <div class="layout__padding-20px">
                    <h3 class="text__align-center text__colour-teal layout__padding-20px">
                        My Order Summary</h3>
                    <div class="layout__height-100 layout__padding-20-0 layout__position-center">
                        <div class="">
                            <div class="component__forms-4">
                                <div class="component__subtitle text__colour-teal">Uploaded Photos</div>
                            </div>
                            <div class="component__forms-4">
                                <div class="component__subtitle text__colour-teal">Photo Enhancements</div>
                            </div>
                            <div class="component__forms-4">
                                <div class="text__colour-teal">Supporting Information</div>
                            </div>

                            <div class="component__forms-4">
                                <div class="component__subtitle text__colour-teal">Supporting Photos</div>
                            </div>
                        </div>
                    </div>


                    <div class="">
                        <table v-for="(order, index) in job.orders">
                            <tr>
                                <td class="layout__border__bottom-none">
                                    <div class="">
                                        <div class="component__forms-4">
                                            <div class="layout__width-150px">
                                                <div class="component__thumbnails-leading">
                                                    <img class="component__thumbnails-leading"
                                                         v-bind:src="order.leadImageUrlThumb"/>
                                                    <img class="component__icon-18-left layout__cursor-pointer"
                                                         src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/bin.png"
                                                         v-on:click="removeDialog(order, index)">
                                                    <img class="component__icon-18-right layout__cursor-pointer"
                                                         src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/edit.png" v-on:click="amendOrder()">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="component__forms-4 text__align-center layout__position-left">
                                            <div class="component__padding-left-right"
                                                 v-for="(task) in order.taskItems">
                                                <span v-show="task.taskType === 'Brighten Image'"
                                                      class="layout__position-left">
                                                    <i class="text__size-45 icon-brighten text__colour-teal"></i>
                                                </span>
                                                <span v-show="task.taskType === 'Add Blue Sky'"
                                                      class="layout__position-left">
                                                    <i class="text__size-45 icon-sky text__colour-teal"></i>
                                                </span>
                                                <span v-show="task.taskType === 'Increase Vibrancy'"
                                                      class="layout__position-left">
                                                        <i class="text__size-45 icon-vibrance text__colour-teal"></i>
                                                </span>
                                                <span v-show="task.taskType === 'Correct Distortion'"
                                                      class="layout__position-left">
                                                    <i class="text__size-45 icon-distortion text__colour-teal"></i>
                                                </span>
                                                <span v-show="task.taskType === 'Add Grass'"
                                                      class="layout__position-left">
                                                    <i class="text__size-45 icon-add-grass text__colour-red"></i>
                                                </span>
                                                <span v-show="task.taskType === 'Remove Object'"
                                                      class="layout__position-left">
                                                    <i class="text__size-45 icon-remove text__colour-red"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="component__forms-4 layout__position-left component__subtitle">
                                            <p v-if="order.information">{{order.information}}</p>

                                            <p v-if="order.information === null || order.information === ''">
                                                No Supporting Information
                                            </p>
                                        </div>

                                        <div class="component__forms-4 layout__position-right">
                                            <p v-if="order.supportingAttachments.length > 0">
                                                {{order.supportingAttachments.length}} Supporting Photo<span
                                                    v-if="order.supportingAttachments.length > 1">s</span>
                                            </p>
                                            <p v-if="order.supportingAttachments.length === 0">
                                                No Supporting Photos
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="text__align-center">
                        <el-button
                                class="button-teal button__base layout__width-200px layout__margin-20-0"
                                v-on:click="amendOrder()">Amend Order
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="colour__background-light-grey layout__position-left layout__width-100" v-show="this.job.userReference != null && this.job.userReference != ''">
                <div class="layout__padding-clear layout__width-80">
                    <div class="layout__padding-20px text__align-right layout__position__relative">
                        <h3 class="text__align-center text__colour-teal layout__padding-20px">
                            My Checkout
                            Summary</h3>

                      <router-link to="/directmailr" class="link__colour-teal">
                        <el-button class="button__background-tickled-pink button__promo photofixr-checkout preserve-bg">
                          <h3 class="mb-0">
                            20/20 campaigns <br><br>
                            from just £22.80
                          </h3>
                        </el-button>
                      </router-link>

                        <div class="layout__width-100">
                            <p class="text__colour-teal layout__padding-20-0 text__size-18">
                                You've uploaded {{this.job.orders.length}} photo<span v-if="this.job.orders.length > 1">s</span>
                            </p>
                            <div class="layout__padding-10px-0">
                                <p v-show="this.basic > 0" class="">
                                    {{this.basic}}x Photofixr with Basic Photofix (£2.95 each):
                                    {{this.returnFormattedCurrency(this.job.standardItemsPrice)}}
                                </p>
                                <p v-show="this.advance > 0" class="">
                                    {{this.advance}}x Photofixr with Advanced Photofix (£5.95 each):
                                    {{this.returnFormattedCurrency(this.job.bespokeItemsPrice)}}
                                </p>
                            </div>

                            <p class="layout__width-100 layout__padding-10px-0">
                                Sub Total: {{this.returnFormattedCurrency(this.job.netTotalBeforeDiscount)}}
                            </p>

                            <p v-if="voucherApplied" class="text__colour-red layout__padding-10px-0">
                                <span v-if="voucherApplied !== '' && (voucherApplied == '10%' || voucherApplied == '20%')">Volume</span>
                                <span v-if="voucherApplied !== '' && (voucherApplied != '10%' && voucherApplied != '20%')">Voucher</span>
                                discount applied ({{voucherApplied}}): -{{this.returnFormattedCurrency(this.job.voucherValue)}}
                            </p>

                            <p class="layout__width-100 layout__padding-10px-0">
                                VAT: {{this.returnFormattedCurrency(this.job.vatTotalPrice)}}
                            </p>


                            <div class="component__price-title layout__width-100 text__align-right text__colour-teal layout__border__top-1px layout__margin-10-0 layout__padding-20-0">
                                Total: {{this.returnFormattedCurrency(this.job.grossTotalPrice)}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-80" v-show="this.job.userReference != null && this.job.userReference != ''">
                <div class="layout__padding-20px layout__position__relative">
                    <h3 class="text__align-center text__colour-teal layout__padding-20px">My Payment Options</h3>

                    <div class="layout__padding-clear" v-show="hideAllPaymentOptions">
                        <div class="text__align-center">
                            <el-button class="button-red button__base layout__margin__right-20px layout__width-200px"
                                       :disabled="this.job.userReference == null"
                                       v-show="showNormalPaymentOptions && browser !== 'ie'"
                                       v-on:click="activateCheckout = true">Pay Online
                            </el-button>
                            <el-button
                                    class="button-red button__base layout__width-200px"
                                    :disabled="this.job.userReference == null || this.disableAccountButton"
                                    v-show="payAccount && showNormalPaymentOptions"
                                    v-on:click="checkoutAccount()">Pay on Account
                            </el-button>

                            <el-button class="button-red button__base layout__width-200px"
                                       :disabled="this.job.userReference == null"
                                       v-show="!showNormalPaymentOptions"
                                       v-on:click="checkoutFOC()">Complete Order
                            </el-button>
                        </div>



                        <div v-show="!(payAccount) && browser === 'ie'" class="text__colour-red text__align-center">

                            We're really sorry!<br>
                            Online payments are currently unsupported in Internet Explorer<br>
                            We've saved your basket, please login and place your order using a different browser<br>
                            <div class="layout__padding-20-0">
                                <p>Alternatively, please contact our Ravensworth Client Services team who will be happy to resolve this issue:  </p>
                                <p>01865 712211</p>
                                <p>orders@printconcern.co.uk</p>
                            </div>

                        </div>
                    </div>

                    <div class="layout__padding-clear" v-show="!hideAllPaymentOptions">
                        <p class="text__align-center text__colour-red layout__padding-20px">Minimum order value: 50p. Please review your order.</p>
                    </div>

                    <div v-show="this.disableAccountButton" class="text__align-center layout__padding-20-0">

                        <p class="text__colour-red">Your credit account appears to be on hold. You can continue to purchase the order using a Credit or Debit card.</p>


                        <div class="layout__padding-20-0">
                            <p>Alternatively, please contact our Ravensworth Client Services team who will be happy to resolve this issue:  </p>
                            <p>01865 712211</p>
                            <p>orders@printconcern.co.uk</p>
                        </div>
                    </div>

                    <p v-show="!(payAccount)" class="text__align-center layout__padding-20-0">If you would like to setup a credit account and
                        be billed monthly
                        please email
                        <a href="mailto:customer.services@ravensworth.co.uk" class="link__colour-teal" target="_top">customer.services@ravensworth.co.uk</a>
                    </p>
                </div>
            </div>
        </div>


        <el-dialog
                :visible.sync="activateDeleteDialog"
                width="500px">
            <div class="layout__position-center text__align-center">
                <div class="layout__position-center text__align-center">
                    <h3 class="text__colour-teal">Are you sure you want to delete the photo?</h3>
                    <div class="layout__padding-clear">
                        <div class="layout__padding-20-0">
                            <el-button
                                    class="button-teal button__base layout__margin__right-20px layout__width-150px"
                                    v-on:click="removeOrder()">Yes
                            </el-button>
                            <el-button class="button-red button__base layout__width-150px"
                                       v-on:click="activateDeleteDialog = false">No
                            </el-button>
                        </div>
                    </div>
                </div>

            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="activateFOCMessageDialog"
                width="500px"
                class="rounded">
            <div class="layout__position-center text__align-center">
                <h3 class="text__colour-teal layout__padding-20-0">Would you like to proceed with the order?</h3>
                <p class="">{{ this.checkoutMessage }}</p>
            </div>

            <div class="layout__padding-clear">
                <div class="layout__padding-20-0 text__align-center">
                    <el-button class="button-red button__base layout__width-150px layout__margin__right-20px"
                               v-on:click="completeFOC()">Confirm Order
                    </el-button>
                    <el-button class="button-teal button__base layout__width-150px"
                               v-on:click="activateFOCMessageDialog = false">Cancel
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="activateMessageDialog"
                width="500px"
                class="rounded">
            <div class="layout__position-center text__align-center">
                <h3 class="text__colour-teal layout__padding-20-0">Would you like to proceed with the order?</h3>
                <p class="layout__padding-0-40px">{{ this.checkoutMessage }}</p>
            </div>

            <div class="layout__padding-clear">
                <div class="layout__padding-20-0 text__align-center">
                    <el-button class="button-red button__base layout__width-150px layout__margin__right-20px"
                               v-on:click="completeAccount()">Confirm Order
                    </el-button>
                    <el-button class="button-teal button__base layout__width-150px"
                               v-on:click="activateMessageDialog = false">Cancel
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="paymentErrorDialog"
                width="500px"
                class="rounded">
            <div class="layout__position-center text__align-center">
                <h3 class="text__colour-teal layout__padding-20-0">Error completing transaction</h3>
                <p class="text__size-16">{{ this.paymentErrorMessage }}</p>

                <div class="layout__padding-20-0">
                    <p>Please contact our Ravensworth Client Services team </p>
                    <p>01865 712211</p>
                    <p>orders@printconcern.co.uk</p>
                </div>
            </div>

            <div class="layout__padding-20-0 text__align-center">
                <el-button class="button-teal button__base layout__width-150px text__align-center" type="primary"
                           v-on:click="paymentErrorDialog = false">Ok
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
                id="checkoutDialog"
                :visible.sync="activateCheckout"
                width="350px"
                class="rounded"
                @opened="openCheckout()"
          @closed="onClosed"
        >
            <div slot="title" class="checkoutTitle">
                <img class="checkoutPhotofixrLogo" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/basicIcon.png">
                <div class="checkoutHeaderLine1">Photofixr Payment</div><br><div class="checkoutHeaderLine2">Complete transaction of &pound;{{ job.grossTotalPrice }}</div>
            </div>
            <form
                id="payment-form"
                method="POST"
                action="https://merchant.com/charge-card"
                >
                <div class="custom-label">
                    <label for="card-number">Card number</label>
                </div>
                <div class="input-container card-number">
                    <div class="icon-container">
                        <img
                            id="icon-card-number"
                            src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/card.svg"
                            alt="PAN"
                            />
                    </div>
                    <div class="card-number-frame"></div>
                    <div class="icon-container payment-method">
                        <img id="logo-payment-method" />
                    </div>
                    <div class="icon-container">
                        <img id="icon-card-number-error" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg" />
                    </div>
                </div>
                <div class="date-and-code">
                    <div>
                        <div class="custom-label">
                            <label for="expiry-date">Expiry date</label>
                        </div>
                        <div class="input-container expiry-date">
                            <div class="icon-container">
                                <img
                                    id="icon-expiry-date"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/exp-date.svg"
                                    alt="Expiry date"
                                    />
                            </div>
                            <div class="expiry-date-frame"></div>
                            <div class="icon-container">
                                <img
                                    id="icon-expiry-date-error"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
                                    />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="custom-label">
                            <label for="cvv">Security code</label>
                        </div>
                        <div class="input-container cvv">
                            <div class="icon-container">
                                <img id="icon-cvv" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/cvv.svg" alt="CVV" />
                            </div>
                            <div class="cvv-frame"></div>
                            <div class="icon-container">
                                <img id="icon-cvv-error" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg" />
                            </div>
                        </div>
                    </div>
                </div>
                <button id="pay-button" disabled="">
                    Pay with Card &pound;{{ job.grossTotalPrice }}
                </button>
                <div>
                    <span class="error-message error-message__card-number"></span>
                    <span class="error-message error-message__expiry-date"></span>
                    <span class="error-message error-message__cvv"></span>
                </div>
                <p class="payment-error-message"></p>
                <p class="success-payment-message"></p>
            </form>
        </el-dialog>

    </div>


</template>

<script>
    import Vue from 'vue';
    import Router from '../../../router';
    import Axios from 'axios';
    import {Loading} from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import StepGuide from "../../../components/tools/photofixr/StepGuide.vue";

    export default {
        name: "checkout",
        mixins: [axios, dataFormatter, backing],
        components: {
            StepGuide
        },
        created() {
            if (this.returnCookie('_token') === null) {
                Router.push({
                    name: '/photofixr/selections'
                });
            } else {
                this.fixes = JSON.parse(window.sessionStorage.getItem('_fixes'))

                this.jobId = window.sessionStorage.getItem('_jobId')
                this.basic = this.fixes["basicOrders"]
                this.advance = this.fixes["advanceOrders"]

                const getJobUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId + '/?random=' + Math.random();
                Axios.get(getJobUrl, this.returnHeaderUsingToken())
                    .then(response => {
                        this.job = response.data;
                        // this.formatCurrency()
                        console.log(this.job)
                        // todo this is just showing the bulk discount onload

                        this.reworkedVouchers('empty')

                        this.rerenderPaymentOptions()
                    });

                const address = JSON.parse(this.returnCookie('_customer'))
                console.log(address.id)

                // const address = JSON.parse(window.sessionStorage.getItem('_customer'))
                this.billingAddress.addr1 = address.address1
                this.billingAddress.addr2 = address.address2
                this.billingAddress.addr3 = address.address3
                this.billingAddress.town = address.town
                this.billingAddress.county = address.county
                this.billingAddress.postcode = address.postcode

                /*if (JSON.parse(this.returnCookie('_role')).includes('AccountCustomer')) {
                    this.disabledAddress = true;
                }*/

                if (this.returnCookie('_customer') === 'undefined' || this.returnCookie('_customer') === null) {
                    if (JSON.parse(this.returnCookie('_role')).includes('AccountCustomer')) {
                        this.disabledAddress = true;
                        this.payAccount = true;
                    }
                } else {
                    const customer = JSON.parse(this.returnCookie('_customer'));

                    if (customer.accountType !== undefined && customer.accountType == 'ACCOUNT') {
                        this.disabledAddress = true;
                        this.payAccount = true;
                    }
                }

                if (JSON.parse(this.returnCookie('_customer')).status === 'ON HOLD') {
                    this.disableAccountButton = true;
                }
            }

            const { detect } = require('detect-browser');
            const browser = detect();

            this.browser = browser.name;

            // console.log(browser.name);
            // console.log(browser.version);
            // console.log(browser.os);
            //
            // switch (browser && browser.name) {
            //     case 'chrome':
            //     case 'firefox':
            //         console.log('supported');
            //         break;
            //
            //     case 'edge':
            //         console.log('kinda ok');
            //         break;
            //
            //     default:
            //         console.log('not supported');
            // }


        },
        beforeUpdate() {
            window.sessionStorage.setItem('_fixes', JSON.stringify(this.fixes));
        },
        mounted() {
            if (typeof this.returnCookie('_token') === 'undefined') {
                document.getElementById('openLogin').click()
            }
        },
        data() {
            return {
                browser: '',
                job: {
                    orders: [],
                    totalPrice: 0.00,
                },
                showNormalPaymentOptions: true,
                hideAllPaymentOptions: true,
                disableAccountButton: false,
                voucherApplied: '',
                voucherUsed: '',
                voucherDiscount: '',
                volumeDiscount: '',
                voucherInformation: '',
                voucherDisplay: '',
                disabledAddress: false,
                billingAddress: {
                    addr1: '',
                    addr2: '',
                    addr3: '',
                    town: '',
                    county: '',
                    postcode: '',
                },
                basic: '',
                advance: '',
                activateDeleteDialog: false,
                order: {},
                index: '',
                fixes: {},
                activateMessageDialog: false,
                activateFOCMessageDialog: false,
                checkoutMessage: '',
                paymentErrorDialog: false,
                paymentErrorMessage: '',
                payAccount: false,
                activateCheckout: false,
                token: '',
                rules: {
                    userReference: [{
                        required: true, message: 'a job reference is required', trigger: 'blur'
                    }],
                    addr1: [{
                        required: true, message: 'required address line 1', trigger: 'blur'
                    }],
                    town: [{
                        required: true, message: 'required town', trigger: 'blur'
                    }],
                    county: [{
                        required: true, message: 'required county', trigger: 'blur'
                    }],
                    postcode: [{
                        required: true, message: 'required postcode', trigger: 'blur'
                    }],
                }
            }
        },
        methods: {
            rerenderPaymentOptions() {
                // const something = this.job.grossTotalPrice.split('£')

                if (this.job.grossTotalPrice === 0.00) {
                    console.log('changing value')
                    this.showNormalPaymentOptions = false;
                }

                if (this.job.grossTotalPrice > '0.00' && this.job.grossTotalPrice < 0.50) {
                    this.hideAllPaymentOptions = false
                }
            },
            updateReference() {
                console.log(this.job.userReference)
                if (this.job.userReference !== null) {
                    if (this.job.userReference !== '') {
                        if (this.job.userReference !== ' ') {
                            const referenceUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id + '/?userreference=' + this.job.userReference + '&random=' + Math.random();
                            // const authOptions = {
                            //     method: 'PUT',
                            //     url: referenceUrl,
                            //     headers: {
                            //         'content-type': 'application/json',
                            //         'Access-Control-Allow-Origin': '*',
                            //         Authorization: 'Bearer ' + this.returnCookie('_token')
                            //     },
                            //     json: true
                            // };
                            //
                            // console.log(authOptions)








                            Axios.put(referenceUrl, {}, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log(response.data);
                                    this.job = response.data;
                                    // this.formatCurrency()
                                    console.log('user reference after update = ' + this.job.userReference);
                                    this.reworkedVouchers('empty');
                                })
                                .catch(error => {
                                    console.log(error);
                                })
                        }
                    }
                } else {
                    console.log('nothing ' + this.job.userReference)
                }
            },
            updateBillingAddress() {

                const customer = JSON.parse(this.returnCookie('_customer'))

                const updateAddress = {
                    "id": customer.id,
                    "address1": this.billingAddress.addr1,
                    "address2": this.billingAddress.addr2,
                    "address3": this.billingAddress.addr3,
                    "town": this.billingAddress.town,
                    "county": this.billingAddress.county,
                    "postcode": this.billingAddress.postcode
                }

                console.log('UPDATING THE ADDRESS')
                console.log(updateAddress)

                const updateAddressUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/Update`
                Axios.put(updateAddressUrl, updateAddress, this.returnHeaderUsingToken())
                    .then(response => {
                        window.sessionStorage.setItem('_customer', JSON.stringify(response.data.result))
                    })
            },
            validateVoucher() {

                const voucherUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/${this.job.id}/?voucherused=${this.job.voucherUsed}&random=${Math.random()}`;
                console.log(voucherUrl)
                // const authOptions = {
                //     method: 'PUT',
                //     url: voucherUrl,
                //     headers: {
                //         'content-type': 'application/json',
                //         'Access-Control-Allow-Origin': '*',
                //         Authorization: 'Bearer ' + this.returnCookie('_token')
                //     },
                //     json: true
                // };








                Axios.put(voucherUrl, {}, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log("VOUCHER");
                        console.log(response.data)
                        // todo this has to be pulled out and added to a method to be reused by the update ref call
                        const oldVoucher = this.job.voucherUsed
                        this.job = response.data
                        // this.formatCurrency()
                        console.log('old voucher ' + oldVoucher)
                        this.reworkedVouchers(oldVoucher.toUpperCase())
                        this.rerenderPaymentOptions()

                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            isBulkVoucherApplied() {
                //todo always evaluate if a bulk voucher is applied
                if (this.job.voucherUsed === 'PFBULK5PLUS') {
                    this.job.voucherUsed = ''
                    this.voucherApplied = '10%';
                } else if (this.job.voucherUsed === 'PFBULK10PLUS') {
                    this.job.voucherUsed = ''
                    this.voucherApplied = '20%';
                }
            },


            reworkedVouchers(oldVoucher) {
                this.voucherApplied = this.job.voucherUsed;
                document.getElementById("voucherNoticeSuccess").style.display = 'none';
                document.getElementById("voucherNoticeFail").style.display = 'none';

                /**
                 * the parameter will be the voucher submitted into the request - this might on be the voucher applied to the job once it's been returned
                 *
                 * two things going on here - one get the right message on screen underneath the apply voucher button and then pretty print the voucher value and type
                 * messaging will be done like so: message inner text, message style, display block
                 *
                 */


                /**
                 * the voucher has been successfully applied
                 */
                if (oldVoucher === this.job.voucherUsed?.toUpperCase()) {
                    this.isBulkVoucherApplied()
                    document.getElementById("voucherNoticeSuccess").innerText = "Voucher Applied Successfully"
                    document.getElementById("voucherNoticeSuccess").classList.add('component__message-base', 'component__message-success')
                    document.getElementById("voucherNoticeSuccess").style.display = 'block';
                } else if (this.job.offerNotes === 'AppliedVoucherBeatsRequestedVoucher') {
                    /**
                     * if the voucher remains a bulk voucher sort the front-end out
                     */
                    this.isBulkVoucherApplied()
                    this.job.voucherUsed = ''
                    document.getElementById("voucherNoticeFail").innerText = 'Sorry, ' + oldVoucher + ' voucher value is less than the discount already applied. \n Voucher has not been applied'
                    document.getElementById("voucherNoticeFail").classList.add('component__message-base', 'component__message-fail')
                    document.getElementById("voucherNoticeFail").style.display = 'block';

                } else if (this.job.offerNotes === 'Invalid Voucher') {
                    this.job.voucherUsed = ''
                    this.isBulkVoucherApplied()
                    document.getElementById("voucherNoticeFail").innerText = 'Sorry, ' + oldVoucher + ' may not exist or you may not have spent the minimum required value. \n Please review your order or try another voucher'
                    document.getElementById("voucherNoticeFail").classList.add('component__message-base', 'component__message-fail')
                    document.getElementById("voucherNoticeFail").style.display = 'block';

                } else if (this.job.offerNotes === 'Invalid Voucher - usage count exceeded') {
                    this.job.voucherUsed = ''
                    this.isBulkVoucherApplied()
                    document.getElementById("voucherNoticeFail").innerText = 'Sorry, ' + oldVoucher + ' has exceeded usage limits. \n Please try another voucher'
                    document.getElementById("voucherNoticeFail").classList.add('component__message-base', 'component__message-fail')
                    document.getElementById("voucherNoticeFail").style.display = 'block';

                // } else if (this.job.voucherUsed === null && this.job.offerNotes !== null) {
                //     document.getElementById("voucherNoticeSuccess").style.display = 'none';
                //     document.getElementById("voucherNoticeFail").style.display = 'none';
                //     this.isBulkVoucherApplied()

                } else {
                    this.isBulkVoucherApplied()
                    document.getElementById("voucherNoticeSuccess").style.display = 'none';
                    document.getElementById("voucherNoticeFail").style.display = 'none';
                }
            },
            amendOrder() {
                Router.push({
                    name: '/photofixr/selections'
                })
            },
            removeDialog(order, index) {
                this.activateDeleteDialog = true
                this.order = order
                this.index = index
            },
            removeOrder() {
                console.log('removing the order ' + this.order.id)
                this.fixes.orderFixes.splice(this.index, 1);
                console.log(this.fixes)
                this.job.orders.splice(this.index, 1);

                const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id + '/orders/' + this.order.id + '&random=' + Math.random();
                Axios.delete(url, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        this.job = response.data;
                        // this.formatCurrency()
                        console.log('job after deleted ' + this.job)

                        const basketTotals = {
                            photofixr: response.data.orders.length
                        }

                        this.$store.dispatch("incrementPhotofixrTotal", basketTotals)
                    });
                this.activateDeleteDialog = false
                this.calculateBasicAdvanceOrders();

            },
            calculateBasicAdvanceOrders() {

                this.fixes.basicOrders = 0
                this.fixes.advanceOrders = 0

                for (let i = 0; i < this.fixes.orderFixes.length; i++) {
                    const orderFix = this.fixes.orderFixes[i];

                    if (orderFix.add_grass == true || orderFix.remove_object == true) {
                        console.log('adding advanced')
                        this.fixes.advanceOrders++
                    } else {
                        console.log('adding basic')
                        this.fixes.basicOrders++
                    }
                }

                if (this.job.orders.length === 0) {
                    Router.push({
                        name: '/photofixr'
                    });

                    // document.getElementById('startPhotofixrUpload').click()
                }
            },
            checkoutAccount() {

                this.checkoutMessage = 'Please confirm you would like this order to be charged to your account?'
                this.activateMessageDialog = true
            },

            checkoutFOC() {

                this.checkoutMessage = 'Please confirm you would like to complete your order?'
                this.activateFOCMessageDialog = true
            },
            completeFOC() {

                const finaliseAccountUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id + '/?paymentValidationToken=foc' + '&random=' + Math.random();
                console.log(finaliseAccountUrl)


                // const authOptions = {
                //     method: 'PUT',
                //     url: finaliseAccountUrl,
                //     headers: {
                //         'content-type': 'application/json',
                //         'Access-Control-Allow-Origin': '*',
                //         Authorization: 'Bearer ' + this.returnCookie('_token')
                //     },
                //     json: true
                // };


                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                Axios.put(finaliseAccountUrl, {}, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        console.log("FINALISE account");
                        console.log('response from the account finalise method ' + response.data)

                        this.job = response.data
                        // this.formatCurrency()

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                        if (this.job.jobFinalised) {
                            Router.push({
                                name: '/photofixr/confirmation',
                                params: {
                                    job: this.job
                                }
                            })
                            this.activateMessageDialog = false

                        } else {
                            this.activateMessageDialog = false
                            this.paymentErrorDialog = true
                            this.paymentErrorMessage = ''
                        }

                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                        this.activateMessageDialog = false
                        this.paymentErrorDialog = true
                        this.paymentErrorMessage = ''
                        console.log(error);
                    })
            },
            completeAccount() {

                const finaliseAccountUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id + '/?paymentValidationToken=account' + '&random=' + Math.random();
                console.log(finaliseAccountUrl)


                // const authOptions = {
                //     method: 'PUT',
                //     url: finaliseAccountUrl,
                //     headers: {
                //         'content-type': 'application/json',
                //         'Access-Control-Allow-Origin': '*',
                //         Authorization: 'Bearer ' + this.returnCookie('_token')
                //     },
                //     json: true
                // };


                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                Axios.put(finaliseAccountUrl, {}, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        console.log("FINALISE account");
                        console.log('response from the account finalise method ' + response.data)

                        this.job = response.data
                        // this.formatCurrency()

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                        if (this.job.jobFinalised) {
                            Router.push({
                                name: '/photofixr/confirmation',
                                params: {
                                    job: this.job
                                }
                            })
                            this.activateMessageDialog = false

                        } else {
                            this.activateMessageDialog = false
                            this.paymentErrorDialog = true
                            this.paymentErrorMessage = ''
                        }

                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                        this.activateMessageDialog = false
                        this.paymentErrorDialog = true
                        this.paymentErrorMessage = ''
                        console.log(error);
                    })
            },
            // formatCurrency() {
            //     this.job.standardItemsPrice = this.returnFormattedCurrency(this.job.standardItemsPrice)
            //     this.job.bespokeItemsPrice = this.returnFormattedCurrency(this.job.bespokeItemsPrice)
            //     this.job.netTotalPrice = this.returnFormattedCurrency(this.job.netTotalPrice)
            //     this.job.vatTotalPrice = this.returnFormattedCurrency(this.job.vatTotalPrice)
            //     this.job.grossTotalPrice = this.returnFormattedCurrency(this.job.grossTotalPrice)
            //     this.job.voucherValue = this.returnFormattedCurrency(this.job.voucherValue)
            // },

            openCheckout() {
                console.log('openCheckout');

                var _this = this;

                if (document.getElementById("checkoutScript")) {
                    var element = document.getElementById("checkoutScript");
                    element.parentNode.removeChild(element);
                }

                if (!document.getElementById("checkoutScript")) {
                    let checkoutScript = document.createElement('script');
                    checkoutScript.onload = async function () {
                        var payButton = document.getElementById("pay-button");
                        var form = document.getElementById("payment-form");
                        var amount;

                        const publicKey = { publicKey: `${process.env.VUE_APP_CHECKOUTKEY}`};

                        Frames.init(publicKey);

                        var logos = generateLogos();

                        function generateLogos() {
                            var logos = {};
                            logos["card-number"] = {
                                src: "card",
                                alt: "card number logo",
                            };
                            logos["expiry-date"] = {
                                src: "exp-date",
                                alt: "expiry date logo",
                            };
                            logos["cvv"] = {
                                src: "cvv",
                                alt: "cvv logo",
                            };
                            return logos;
                        }

                        var errors = {};
                        errors["card-number"] = "Please enter a valid card number";
                        errors["expiry-date"] = "Please enter a valid expiry date";
                        errors["cvv"] = "Please enter a valid cvv code";

                        Frames.removeAllEventHandlers(Frames.Events.FRAME_VALIDATION_CHANGED);
                        Frames.addEventHandler(
                            Frames.Events.FRAME_VALIDATION_CHANGED,
                            onValidationChanged
                        );

                        function onValidationChanged(event) {
                            var e = event.element;

                            if (event.isValid || event.isEmpty) {
                                if (e === "card-number" && !event.isEmpty) {
                                    showPaymentMethodIcon();
                                }
                                setDefaultIcon(e);
                                clearErrorIcon(e);
                                clearErrorMessage(e);
                            } else {
                                if (e === "card-number") {
                                    clearPaymentMethodIcon();
                                }
                                setDefaultErrorIcon(e);
                                setErrorIcon(e);
                                setErrorMessage(e);
                            }
                        }

                        function clearErrorMessage(el) {
                            var selector = ".error-message__" + el;
                            var message = document.querySelector(selector);
                            message.textContent = "";
                        }

                        function clearErrorIcon(el) {
                            var logo = document.getElementById("icon-" + el + "-error");
                            logo.style.removeProperty("display");
                        }

                        function showPaymentMethodIcon(parent, pm) {
                            if (parent) parent.classList.add("show");

                            var logo = document.getElementById("logo-payment-method");
                            if (pm) {
                                var name = pm.toLowerCase();
                                logo.setAttribute("src", "https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/" + name + ".svg");
                                logo.setAttribute("alt", pm || "payment method");
                            }
                            logo.style.removeProperty("display");
                        }

                        function clearPaymentMethodIcon(parent) {
                            if (parent) parent.classList.remove("show");

                            var logo = document.getElementById("logo-payment-method");
                            logo.style.setProperty("display", "none");
                        }

                        function setErrorMessage(el) {
                            var selector = ".error-message__" + el;
                            var message = document.querySelector(selector);
                            message.textContent = errors[el];
                        }

                        function setDefaultIcon(el) {
                            var selector = "icon-" + el;
                            var logo = document.getElementById(selector);
                            logo.setAttribute("src", "https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/" + logos[el].src + ".svg");
                            logo.setAttribute("alt", logos[el].alt);
                        }

                        function setDefaultErrorIcon(el) {
                            var selector = "icon-" + el;
                            var logo = document.getElementById(selector);
                            logo.setAttribute("src", "https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/" + logos[el].src + "-error.svg");
                            logo.setAttribute("alt", logos[el].alt);
                        }

                        function setErrorIcon(el) {
                            var logo = document.getElementById("icon-" + el + "-error");
                            logo.style.setProperty("display", "block");
                        }

                      console.log(Frames);
                      Frames.removeAllEventHandlers(Frames.Events.CARD_VALIDATION_CHANGED);
                        Frames.addEventHandler(
                            Frames.Events.CARD_VALIDATION_CHANGED,
                            cardValidationChanged
                        );

                        function cardValidationChanged() {
                            if (amount == 0.00) {
                                payButton.disabled = true;
                            } else {
                                payButton.disabled = !Frames.isCardValid();
                            }
                        }

                        Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZATION_FAILED);
                        Frames.addEventHandler(
                            Frames.Events.CARD_TOKENIZATION_FAILED,
                            onCardTokenizationFailed
                        );

                        function onCardTokenizationFailed(error) {
                            console.log("CARD_TOKENIZATION_FAILED: %o", error);
                            Frames.enableSubmitForm();
                        }

                        Frames.removeEventHandler(Frames.Events.CARD_TOKENIZED, onCardTokenized);
                        Frames.addEventHandler(
                            Frames.Events.CARD_TOKENIZED,
                            onCardTokenized
                        );

                        function onCardTokenized(event) {
                            //var el = document.querySelector(".success-payment-message");
                            //el.innerHTML =
                            //    "Card tokenization completed<br>" +
                            //    'Your card token is: <span class="message-info">' +
                            //    event.token +
                            //    "</span>";

                            console.log('token');
                            console.log(event.token);

                            if (event.token !== _this.token) {
                                _this.token = event.token;

                                const finaliseOnlineUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + _this.job.id + '/?paymentValidationToken=' + event.token + '&random=' + Math.random();
                                console.log(finaliseOnlineUrl);

                                // const authOptions = {
                                //     method: 'PUT',
                                //     url: finaliseOnlineUrl,
                                //     headers: {
                                //         'content-type': 'application/json',
                                //         'Access-Control-Allow-Origin': '*',
                                //         Authorization: 'Bearer ' + this.returnCookie('_token')
                                //     },
                                //     json: true
                                // };
                                let loadingInstance = Loading.service({
                                    fullscreen: true
                                });
                                Axios.put(finaliseOnlineUrl, {}, _this.returnHeaderUsingToken())
                                    .then(response => {
                                        _this.onClosed();

                                        console.log("FINALISE");
                                        console.log('response from the finalise method ' + response.data)

                                        _this.job = response.data
                                        // _this.formatCurrency()

                                        console.log(_this.job.jobFinalised)
                                        console.log(typeof _this.job.jobFinalised)

                                        _this.$nextTick(() => { // Loading should be closed asynchronously
                                            loadingInstance.close();
                                        });

                                        _this.token = '';

                                        if (_this.job.jobFinalised) {

                                            // this.$checkout.close();

                                            Router.push({
                                                name: '/photofixr/confirmation',
                                                params: {
                                                    job: _this.job
                                                }
                                            })
                                            _this.activateMessageDialog = false
                                            _this.activateCheckout = false

                                        } else {
                                            // alert('failed to take payment')
                                            _this.activateMessageDialog = false
                                            _this.paymentErrorDialog = true
                                            _this.paymentErrorMessage = ''
                                            _this.activateCheckout = false
                                        }

                                    })
                                    .catch(error => {
                                        _this.onClosed();

                                        _this.activateMessageDialog = false
                                        _this.paymentErrorDialog = true
                                        _this.paymentErrorMessage = ''
                                        _this.activateCheckout = false

                                        _this.$nextTick(() => { // Loading should be closed asynchronously
                                            loadingInstance.close();
                                        });

                                        _this.token = '';
                                        console.log(error);
                                    })
                            }
                        }

                        Frames.removeAllEventHandlers(Frames.Events.PAYMENT_METHOD_CHANGED);
                        Frames.addEventHandler(
                            Frames.Events.PAYMENT_METHOD_CHANGED,
                            paymentMethodChanged
                        );

                        function paymentMethodChanged(event) {
                            var pm = event.paymentMethod;
                            let container = document.querySelector(".icon-container.payment-method");

                            if (!pm) {
                                clearPaymentMethodIcon(container);
                            } else {
                                clearErrorIcon("card-number");
                                showPaymentMethodIcon(container, pm);
                            }
                        }

                        form.addEventListener("submit", onSubmit);

                        function onSubmit(event) {
                            console.log('onSubmit');

                            event.preventDefault();
                            Frames.submitCard();
                        }
                    }

                    checkoutScript.setAttribute('src', 'https://cdn.checkout.com/js/framesv2.min.js');
                    checkoutScript.async = true;
                    checkoutScript.id = "checkoutScript";
                    document.head.appendChild(checkoutScript);
                }
            },

          onClosed() {
            Frames.removeAllEventHandlers(Frames.Events.PAYMENT_METHOD_CHANGED);
            Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZED);
            Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZATION_FAILED);
            Frames.removeAllEventHandlers(Frames.Events.CARD_VALIDATION_CHANGED);
            Frames.removeAllEventHandlers(Frames.Events.FRAME_VALIDATION_CHANGED);
          },
        }
    };
</script>
